import React, { useEffect, useState } from 'react';
import { useQuery } from '@apollo/client';
import { useSearchParams } from 'react-router-dom';

import BuyerRegistrationPanel from './BuyerRegistrationPanel';
import { buyerRegistrationStyles } from './BuyerRegistration.styled';
import { GetLoggedInUserQuery } from '../../schema/generated/schema';
import quotesApi from '../../services/quotes';
import { convertToQuoteSubdomain } from '../../utils/helpers';

const BuyerRegistration = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const destination = searchParams.get('destination');
  const [sharedEmail, setSharedEmail] = useState('');
  const [senderName, setSenderName] = useState('');

  const { data: user } = useQuery(GetLoggedInUserQuery);

  useEffect(() => {
    // if user is already fully registered, redirect them to /quote
    if (user?.me?.registered == true) {
      const url = convertToQuoteSubdomain(destination || '/quote');
      window.location.assign(url);
    }
  }, [user]);

  useEffect(() => {
    if (window.analytics) {
      window.analytics.page('Registration', {
        category: 'Instant Quote Funnel',
        source: 'MigratedGetRegister',
      });
    }
  }, []);

  useEffect(async () => {
    if (token) {
      const response = await quotesApi.fetchSharedQuoteToken(token);
      setSharedEmail(response.shared_email);
      setSenderName(response.sender_name);
    }
  }, [token]);

  return (
    <div css={buyerRegistrationStyles.widgetBody}>
      <BuyerRegistrationPanel
        prefilledEmail={sharedEmail}
        destination={destination}
        handleRegister={(formData) => quotesApi.submitRegister(formData)}
        redirect={(url) => window.location.assign(convertToQuoteSubdomain(url))}
        senderName={senderName}
        handleRedirect={(url) => window.location.assign(url)}
      />
    </div>
  );
};

export default BuyerRegistration;
